import * as viLocale from 'blockly/msg/vi';

/**
 * VIETNAMESE LOCALIZATION DICTIONARY FOR BLOCKLY
 * Bản địa hóa 100% tiếng Việt cho hệ thống Biến số, Danh sách, Menu chuột phải,
 * Thủ tục (Khối của tôi) và Thông báo hệ thống.
 */
export function applyVietnameseLocalization(Blockly) {
  if (!Blockly || !Blockly.Msg) return;

  // 1. Nạp từ điển tiếng Việt chuẩn của Blockly làm nền tảng
  try {
    if (typeof Blockly.setLocale === 'function') {
      Blockly.setLocale(viLocale);
    } else if (viLocale) {
      Object.assign(Blockly.Msg, viLocale);
    }
  } catch (err) {
    console.warn('Lỗi khi nạp từ điển viLocale:', err);
  }

  // 2. Việt hóa và chuẩn hóa toàn bộ các lựa chọn khi bấm chuột phải (Context Menu)
  Blockly.Msg['DUPLICATE_BLOCK'] = 'Tạo bản sao';
  Blockly.Msg['ADD_COMMENT'] = 'Thêm chú thích';
  Blockly.Msg['REMOVE_COMMENT'] = 'Xóa chú thích';
  Blockly.Msg['INLINE_INPUTS'] = 'Dàn hàng ngang';
  Blockly.Msg['EXTERNAL_INPUTS'] = 'Dàn hàng dọc';
  Blockly.Msg['COLLAPSE_BLOCK'] = 'Thu gọn khối';
  Blockly.Msg['EXPAND_BLOCK'] = 'Mở rộng khối';
  Blockly.Msg['DISABLE_BLOCK'] = 'Vô hiệu hóa khối';
  Blockly.Msg['ENABLE_BLOCK'] = 'Kích hoạt khối';
  Blockly.Msg['DELETE_BLOCK'] = 'Xóa khối';
  Blockly.Msg['DELETE_X_BLOCKS'] = 'Xóa %1 khối';
  Blockly.Msg['HELP'] = 'Trợ giúp';

  // Menu ngữ cảnh chuột phải trên Không gian làm việc (Workspace Context Menu)
  Blockly.Msg['UNDO'] = 'Hoàn tác';
  Blockly.Msg['REDO'] = 'Làm lại';
  Blockly.Msg['CLEAN_UP'] = 'Sắp xếp lại các khối';
  Blockly.Msg['COLLAPSE_ALL'] = 'Thu gọn tất cả các khối';
  Blockly.Msg['EXPAND_ALL'] = 'Mở rộng tất cả các khối';
  Blockly.Msg['DELETE_ALL_BLOCKS'] = 'Xóa tất cả %1 khối?';

  // Thủ tục & Khối của tôi (Procedures / Custom Blocks)
  Blockly.Msg['PROCEDURES_DEFNORETURN_TITLE'] = 'định nghĩa';
  Blockly.Msg['PROCEDURES_DEFNORETURN_PROCEDURE'] = 'khối của tôi';
  Blockly.Msg['PROCEDURES_CALLNORETURN_TITLE'] = '';
  Blockly.Msg['PROCEDURES_BEFORE_PARAMS'] = 'với:';
  Blockly.Msg['PROCEDURES_CALL_BEFORE_PARAMS'] = 'với:';
  Blockly.Msg['PROCEDURES_CREATE_DO'] = 'Tạo khối "%1"';
  Blockly.Msg['PROCEDURES_DEFNORETURN_TOOLTIP'] = 'Tạo một khối lệnh tùy chỉnh không có giá trị trả về.';
  Blockly.Msg['PROCEDURES_DEFRETURN_TOOLTIP'] = 'Tạo một khối lệnh tùy chỉnh có giá trị trả về.';
  Blockly.Msg['PROCEDURES_CALLNORETURN_TOOLTIP'] = 'Thực thi khối lệnh tùy chỉnh "%1".';
  Blockly.Msg['PROCEDURES_CALLRETURN_TOOLTIP'] = 'Thực thi khối lệnh tùy chỉnh "%1" và nhận giá trị trả về.';
  Blockly.Msg['PROCEDURES_HIGHLIGHT_DEF'] = 'Đi tới khối định nghĩa';

  // Bản địa hóa Biến số (Variables)
  Blockly.Msg['NEW_VARIABLE'] = 'Tạo một biến số...';
  Blockly.Msg['NEW_STRING_VARIABLE'] = 'Tạo biến chuỗi...';
  Blockly.Msg['NEW_NUMBER_VARIABLE'] = 'Tạo biến số...';
  Blockly.Msg['VARIABLE_ALREADY_EXISTS'] = 'Biến số có tên "%1" đã tồn tại.';
  Blockly.Msg['VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE'] = 'Biến "%1" đã tồn tại với kiểu "%2".';
  Blockly.Msg['RENAME_VARIABLE'] = 'Đổi tên biến số...';
  Blockly.Msg['RENAME_VARIABLE_TITLE'] = 'Đổi tên tất cả biến "%1" thành:';
  Blockly.Msg['DELETE_VARIABLE'] = 'Xóa biến số "%1"';
  Blockly.Msg['DELETE_VARIABLE_CONFIRMATION'] = 'Xóa %1 lần sử dụng của biến số "%2"?';
  Blockly.Msg['VARIABLES_DEFAULT_NAME'] = 'giá trị';
  Blockly.Msg['VARIABLES_SET'] = 'đặt %1 thành %2';
  Blockly.Msg['VARIABLES_CHANGE'] = 'thay đổi %1 một lượng %2';
  Blockly.Msg['MATH_CHANGE_TITLE'] = 'thay đổi %1 một lượng %2';
  Blockly.Msg['VARIABLES_SET_CREATE_GET'] = 'Tạo khối "lấy %1"';
  Blockly.Msg['VARIABLES_GET_CREATE_SET'] = 'Tạo khối "đặt %1"';

  // Bản địa hóa Danh sách dữ liệu (Lists / Arrays)
  Blockly.Msg['NEW_LIST'] = 'Tạo một danh sách...';
  Blockly.Msg['LIST_ALREADY_EXISTS'] = 'Danh sách có tên "%1" đã tồn tại.';
  Blockly.Msg['RENAME_LIST'] = 'Đổi tên danh sách...';
  Blockly.Msg['DELETE_LIST'] = 'Xóa danh sách "%1"';
  Blockly.Msg['LISTS_CREATE_EMPTY_TITLE'] = 'tạo danh sách rỗng';
  Blockly.Msg['LISTS_LENGTH_TITLE'] = 'độ dài của %1';
  Blockly.Msg['LISTS_GET_INDEX_INPUT_IN_LIST'] = 'trong %1';

  // Toán tử số học cơ bản
  Blockly.Msg['MATH_NUMBER_TOOLTIP'] = 'Một con số.';

  // Thông điệp khối điều khiển Đèn LED RGB nâng cao theo phần trăm
  Blockly.Msg['RETOCAR_SET_RGB_PERCENT_TITLE'] = 'bật đèn RGB';
  Blockly.Msg['RETOCAR_SET_RGB_PERCENT_RED'] = 'Đỏ';
  Blockly.Msg['RETOCAR_SET_RGB_PERCENT_GREEN'] = 'Xanh lá';
  Blockly.Msg['RETOCAR_SET_RGB_PERCENT_BLUE'] = 'Xanh dương';
  Blockly.Msg['RETOCAR_SET_RGB_PERCENT_TOOLTIP'] = 'Pha màu tùy ý bằng cách điều chỉnh độ sáng từ 0% đến 100% cho từng bóng LED Đỏ, Xanh lá, Xanh dương. Có thể dùng biến số hoặc phép toán.';

  // Thông điệp khối kiểm tra trạng thái nút bấm (Nút BT1 / BT2)
  Blockly.Msg['RETOCAR_BUTTON_STATE_PRESSED'] = 'nhấn';
  Blockly.Msg['RETOCAR_BUTTON_STATE_RELEASED'] = 'nhả';
  Blockly.Msg['RETOCAR_BUTTON_PRESSED_TOOLTIP'] = 'Kiểm tra trạng thái phím BT1 hoặc BT2 trên robot. Trả về Đúng (True) nếu nút được chọn đang ở trạng thái tương ứng (đang được bấm giữ hoặc đang thả tay).';

  // Thông điệp khối kiểm tra mắt dò đường (S1 / S2 / S3 = vạch đen / trắng)
  Blockly.Msg['RETOCAR_LINE_COLOR_BLACK'] = 'đen';
  Blockly.Msg['RETOCAR_LINE_COLOR_WHITE'] = 'trắng';
  Blockly.Msg['RETOCAR_LINE_DETECTED_TOOLTIP'] = 'Kiểm tra mắt hồng ngoại có phát hiện vạch đen hoặc vạch trắng không';
}

